import React, { useState } from "react";
import {Button, Col, Modal, ModalBody, ModalHeader, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import i18n from "../../../i18n";
import { IoIosClose, IoMdInformationCircleOutline } from "react-icons/io";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import style from "../../../components/PaymentItems/Payment.module.css";

const PaymentInfoItemDynamic = (props) => {
    const {t} = useTranslation();
    const [modalContent,setModalContent] = useState<any>(null)
    const [showModal,setShowModal] = useState<any>(false)
    
    const parseValue = (value) => {
        const parts = value.split('*'); // Split value by `*`
        return parts.map((part, index) =>
            index % 2 === 1 ? <b key={index}>{part}</b> : part
        );
    };
    const viewInfo = (info : any) => {
        setModalContent(info)
        setShowModal(true)
    }

    const hideModal = () => {
        setShowModal(!showModal)
    }

    return <>
        <Row dir={i18n.language === 'en' ? 'ltr' : 'rtl'}>
            <Col>
                {parseValue(props.label)} {props.info ? <IoMdInformationCircleOutline className="cursor__pointer" onClick={() => {viewInfo(props.info)}} style={{color : "#979797" }}/> : ''}
            </Col>
            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                <div>
                    <span>{parseValue(props.value)}</span>
                </div>
            </Col>
        </Row>
        {modalContent && <Modal dir={i18n.language=='en'?'ltr':'rtl'} show={showModal} centered >
         <ModalHeader className={`d-flex flex-column align-items-start ${style.modal_header_info_view} border-bottom-0 fw-bolder pb-0`} style={{fontSize : "24px"}}>
            <span>
                <svg className={"cursor__pointer"} width="16" height="16" onClick={hideModal} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 1.61143L1.61143 0L8 6.38857L14.3886 0L16 1.61143L9.61143 8L16 14.3886L14.3886 16L8 9.61143L1.61143 16L0 14.3886L6.38857 8L0 1.61143Z" fill="black"/>
                </svg>
            </span>
            <span className="mt-3">{modalContent.title}</span>
         </ModalHeader>
         <ModalBody className={` ${style.modal_body_info_view} pb-5`}>
            {modalContent.description}
         </ModalBody>
    </Modal>}
    </>;
};

export default PaymentInfoItemDynamic;
